export enum ResultsHubEvents {
  ReceiveVersichererResponse = 'ReceiveVersichererResponse',
  ReceiveBerechnungResponse = 'ReceiveBerechnungResponse',
}
